/**
 * Nothing typed is lost (round 3): drafts of anything a person starts —
 * an item being added or edited, a playlist link, a pick-my-own set, the
 * Home question's state — live in localStorage until finished or discarded,
 * and survive navigation and app/phone restarts. Per device by design: the
 * server holds finished things, the device holds half-finished ones.
 */
const PREFIX = "instead.draft.";

function read<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

function write(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // storage full or blocked — the form keeps working in memory
  }
}

function clear(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    // ignore
  }
}

export const drafts = { read, write, clear };

/** Remembered Home question state (round 4: never resets by itself). */
export const FILTERS_KEY = "rest.filters";
export const PICK_OWN_KEY = "pick.own";
export const SOURCE_URL_KEY = "source.url";
export const itemDraftKey = (id: string | "new") => `item.${id}`;
/** A shelf selection and its pending bulk edit (D-37): survives the trip to an editor and back. */
export const BULK_EDIT_KEY = "shelf.bulk";
